import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { Heading } from "src/components/base/heading";
import { Text } from "src/components/base/text";

/**
 * The properties for {@link ErrorServerError}
 */
export type ErrorServerErrorProps = {};

/**
 * The error page for tailscale user authentication
 */
export default function ErrorServerError(props: ErrorServerErrorProps) {
    const [t] = useTranslation("static-error");

    return (
        <div className={"flex flex-col items-center justify-center gap-4"}>
            <Heading>{t("heading.tailscale-error")}</Heading>
            <Text>{t("description.tailscale-error")}</Text>
        </div>
    );
}

export const Route = createFileRoute("/_static/s/login/server-error")({
    component: ErrorServerError,
});
